import React, { Fragment, useState, useEffect, useLayoutEffect } from "react";
import { Link } from "react-router-dom";

import authService from "../../../utilities/services/auth.service";

import { createTicketTransfer } from "../../../utilities/api";

import {
  emailPatternMatch,
  formatNumber,
  getSinglarOrPluralWord,
  toggleElement,
  sortTickets,
} from "../../../utilities/helpers";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";

import { BackButton } from "../../BackButton";
import { DisplayTickets } from "../DisplayTickets";
import { Error } from "../../Error";
import { SuccessContainer } from "../SuccessContainer";
import { SuccessDisclaimer } from "../SuccessDisclaimer";
import { Spinner } from "../../LoadingContainer/Spinner";
import { useParams } from "react-router-dom";

export default function TransferModal({
  handleClose,
  setTicketStatus,
  order,
  getMyOrders,
  event,
}) {
  let tickets = order ? order?.tickets : order?.package?.tickets;
  let { eventUUID } = useParams();
  const { getUser } = authService;
  const user = getUser()?.user;

  const isScalper = user?.bulkPurchaser;

  // 1 - tranfer
  // 2 - email address
  // 3 - confirmation
  // 4 - success
  const [step, setStep] = useState(1);

  // select tickets
  const [selectedTickets, setSelectedTickets] = useState([]);

  const [email, setEmail] = useState("");

  const [isValid, setIsValid] = useState(true);

  const [isValidEmail, setIsValidEmail] = useState(true);

  const [isSame, setIsSame] = useState(false);

  const [isSaving, setIsSaving] = useState(false);

  useLayoutEffect(() => {
    let el = document.querySelector(".btn-close");

    if (el) {
      if (step === 4) toggleElement(el, false);

      return () => {
        toggleElement(el, true);
      };
    }
  }, [step]);

  // reset validation
  useEffect(() => {
    setIsValid(true);
    setIsValidEmail(true);
    setIsSame(false);
  }, [email]);

  const groupBySectionRow = (tickets) => {
    const ticketsMap = new Map();

    tickets?.forEach((ticket) => {
      const key = `${ticket.sectionNumber}-${ticket?.rowNumber}`;
      if (!ticketsMap.has(key)) {
        ticketsMap.set(key, {
          tickets: [],
        });
      }
      ticketsMap?.get(key).tickets.push(ticket);
    });

    return ticketsMap;
  };

  const groupAndSortBySectionRow = (tickets) => {
    // Step 1: Group tickets
    const groupedMap = groupBySectionRow(tickets);

    // Step 2: Sort tickets inside each group
    for (const [key, value] of groupedMap.entries()) {
      groupedMap.set(key, {
        ...value,
        tickets: sortTickets(value.tickets),
      });
    }

    // Step 3: Sort groups by section-row key
    return new Map(
      [...groupedMap.entries()].sort(([keyA], [keyB]) =>
        keyA.localeCompare(keyB, undefined, {
          numeric: true,
          sensitivity: "base",
        })
      )
    );
  };

  if (isScalper) {
    tickets = groupAndSortBySectionRow(tickets);
  }
  console.log("scalper tickets", tickets);

  const handleGoBack = () => {
    setStep(step - 1);
  };

  const submit = (e) => {
    if (e) e.preventDefault();
    if (validEmail() && !isSameEmail()) {
      setStep(3);
    } else {
      setIsValid(false);
    }

    if (isSameEmail()) setIsSame(true);

    if (!validEmail()) setIsValidEmail(false);
  };

  const submitTransfer = () => {
    setIsSaving(true);
    let ticketIds = selectedTickets.map((ticket) => ticket.id);
    let data = {
      email: email,
      orderId: order?.id,
      event,
      ticketIds,
      eventUUID,
    };

    createTicketTransfer(data)
      .then((res) => {
        getMyOrders().then(() => {
          setIsSaving(false);

          if (!isSaving) setStep(4);
        });
      })
      .catch((err) => {
        console.error(err);
        setIsSaving(false);
      });
  };

  const validEmail = () => {
    return email && emailPatternMatch(email);
  };

  const isSameEmail = () => {
    return email && email == user?.email;
  };

  const handleClick = () => {
    handleClose();
    if (step === 4) setTicketStatus("transferred");
  };

  return (
    <Fragment>
      <Modal.Header closeButton>
        <Modal.Title as="h5">Transfer</Modal.Title>
      </Modal.Header>
      {step === 1 && (
        <>
          <Modal.Body>
            <DisplayTickets
              status="transfer"
              role="select"
              selectedTickets={selectedTickets}
              setSelectedTickets={setSelectedTickets}
              tickets={tickets}
              isScalper={isScalper}
            />
          </Modal.Body>
          <Stack direction="horizontal" className="btn-group-flex">
            <Button
              onClick={() => setStep(2)}
              className="btn-next"
              size="lg"
              disabled={selectedTickets.length === 0}
            >
              Next
            </Button>
          </Stack>
        </>
      )}
      {step === 2 && (
        <>
          <Modal.Body>
            <div className="modal-body-heading">
              <h4 className="modal-body-heading-title modal-body-heading-title--sm">
                Enter the recipient's email address{" "}
              </h4>
              <p className="small">
                The recipient will get notified via email that you have
                transferred your{" "}
                {getSinglarOrPluralWord(selectedTickets?.length).toLowerCase()}{" "}
                to them.
              </p>
            </div>
            <Form onSubmit={(e) => submit(e)}>
              <Form.Group controlId="email">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="mail@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onBlur={validEmail}
                  className={
                    email && (!isValidEmail || isSame) ? "error-border" : ""
                  }
                  autoFocus
                  required
                />
                {/* not a valid email */}
                {email && !isValidEmail && <Error type="invalidEmail" />}
                {/* is a valid email but is same email */}
                {isValidEmail && isSame && <Error type="transfer" />}
              </Form.Group>
            </Form>
          </Modal.Body>
          <Stack direction="horizontal" className="btn-group-flex">
            <BackButton variant="default" handleGoBack={handleGoBack} />
            <Button
              onClick={submit}
              disabled={!email || !isValid}
              size="lg"
              className="btn-next"
            >
              Next
            </Button>
          </Stack>
        </>
      )}
      {step === 3 && (
        <>
          <Modal.Body>
            <h4 className="modal-body-heading-title modal-body-heading-title--sm">
              You are about to transfer {formatNumber(selectedTickets?.length)}{" "}
              {getSinglarOrPluralWord(selectedTickets?.length).toLowerCase()}
            </h4>
            <DisplayTickets
              selectedTickets={selectedTickets}
              isScalper={isScalper}
              groupAndSortBySectionRow={groupAndSortBySectionRow}
            />
          </Modal.Body>
          <div className="mx-5 pt-4">
            <p className="small small-bold text-muted mb-2">
              Recipient email address
            </p>
            <span className="normal normal-bold">{email}</span>
          </div>
          <Stack direction="horizontal" className="btn-group-flex">
            <BackButton variant="default" handleGoBack={handleGoBack} />
            <Button
              onClick={submitTransfer}
              disabled={isSaving}
              size="lg"
              className="icon-button btn-h"
            >
              {isSaving ? <Spinner /> : "Transfer"}
            </Button>
          </Stack>
        </>
      )}
      {step === 4 && (
        <>
          <Modal.Body>
            <SuccessContainer>
              <h4 className="modal-body-heading-title">
                Your{" "}
                {getSinglarOrPluralWord(selectedTickets?.length).toLowerCase()}{" "}
                have been transferred!{" "}
              </h4>
            </SuccessContainer>

            <p className="small">
              Your transfer is pending till the recipient claims the{" "}
              {getSinglarOrPluralWord(selectedTickets?.length).toLowerCase()}.
              You can cancel the transfer while it's pending. Once it's claimed
              by the recipient the{" "}
              {getSinglarOrPluralWord(selectedTickets?.length).toLowerCase()}{" "}
              will no longer be in your account.
            </p>
            <SuccessDisclaimer />
          </Modal.Body>
          <Stack className="btn-group-flex">
            <Link to="/my-transfers" className="btn btn-lg btn-outline-light">
              Go to My transfers
            </Link>
            {tickets?.length > 0 && (
              <Button onClick={handleClick} size="lg">
                Close
              </Button>
            )}
          </Stack>
        </>
      )}
    </Fragment>
  );
}
